<template>
  <v-dialog v-model="articleSharesDialog" width="750">
    <v-card flat>
      <v-card-title class="display-1 pb-12">{{item.Title}}</v-card-title>
      <v-card-text v-for="item in dummyShares" :key="item.sharerId">
        <div class="pl-5 pb-1">
          <v-avatar v-if="item.image !== ''">
            <img :src="item.image" alt="X">
          </v-avatar>
          <v-avatar v-else color="grey">
            <v-icon>fas fa-user</v-icon>
          </v-avatar>
          <span class="pl-5 title">{{item.name}} </span>
          <span class="pl-3 subtitle-1">{{item.date}} </span>
          <span class="pl-3 title"> 
            <span class="subtitle-1">{{$t('yourArticles.sharedDialog.Shared')}}: </span> 
            <span v-if="item.platform == 'Facebook'">
              <v-btn icon medium outlined class="mt-2 ml-1 mr-1">
                <v-icon>fab fa-facebook-f</v-icon>
              </v-btn>
              <span class="subtitle-1">Facebook</span>
            </span>
            <span v-if="item.platform == 'Instagram'">
              <v-btn icon medium outlined class="mt-2 ml-1 mr-1">
                <v-icon>fab fa-instagram</v-icon>
              </v-btn>
              <span class="subtitle-1">Instagram</span>
            </span>
            <span v-if="item.platform == 'Twitter'">
              <v-btn icon medium outlined class="mt-2 ml-1 mr-1">
                <v-icon>fab fa-twitter</v-icon>
              </v-btn>
              <span class="subtitle-1">Twitter</span>
            </span>
            <span v-if="item.platform == ''">
              <v-btn icon medium outlined class="mt-2 ml-1 mr-1">
                <v-icon>fas fa-times</v-icon>
              </v-btn>
              <span class="subtitle-1">{{$t('yourArticles.sharedDialog.Unable to spot share location')}}</span>
            </span>
          </span>
        </div>
        <v-divider></v-divider>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="articleSharesDialog = false">{{$t('yourArticles.sharedDialog.Close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import messages from "../../modules/lang/main/export";
  export default {
    i18n: { messages },
    data(){
      return{
        item:{},
        articleSharesDialog: false,
        dummyShares:[
          {articleId:22, sharerId:33, name:"Bob", date:"01 February 2020", platform:"Instagram", image:"", alt:"X", shareLocation:""},
          {articleId:22, sharerId:44, name:"Jane", date:"02 February 2020", platform:"Facebook", image:"", alt:"X", shareLocation:""},
          {articleId:22, sharerId:123, name:"John", date:"01 February 2020", platform:"Facebook", image:"https://cdn.vuetifyjs.com/images/john.jpg", alt:"X", shareLocation:""},
          {articleId:22, sharerId:55, name:"Lisa", date:"03 February 2020", platform:"Twitter", image:"", alt:"X", shareLocation:""},
          {articleId:22, sharerId:66, name:"Bruce", date:"03 February 2020", platform:"", image:"", alt:"X", shareLocation:""},
        ],
      }
    },
    methods: {
      openDialog(item) {
        this.item = item;
        this.articleSharesDialog = true;
      },
    }
  }
</script>